module.exports = __webpack_public_path__ + "img/Flunder_10.e22056f7.jpg";